import { FunctionComponent, useState } from "react";
import ModalFiltro from "../../../../../components/modalFiltros";
import { UseListMembros } from "../../context/listMembrosConexoes";
import { SelectSede } from "../../../../../components/selects/sede";
import { SelectMinisterio } from "../../../../../components/selects/ministerio";
import { SelectCelula } from "../../../../../components/selects/celula";
import { Button } from "@mui/material";

interface FiltroPGProps {
}

const FiltroPG: FunctionComponent<FiltroPGProps> = () => {

  const { alterCampos, dados, reset, handleFilter, isLoading } = UseListMembros();

  const [dadoSubmit, setDadoSubmit] = useState<{sede: number, ministerio: number, celula: number}>();

  const submit = async () => {
    try {
      alterCampos('sede', dadoSubmit?.sede);
      alterCampos('ministerio', dadoSubmit?.ministerio);
      alterCampos('celula', dadoSubmit?.celula);
    } finally {
      await handleFilter();
    }
  }

  const alterFilter = (field: 'sede' | 'ministerio' | 'celula', value: any) => setDadoSubmit((valor) => ({...valor, [field]: value}));

  const getSede = (value: string) => alterFilter('sede', value);

  const getMinisterio = (value: any) => alterFilter('ministerio', value?.target?.value)

  const getCelula = (value: any) => alterFilter('celula', value?.target?.value)

  return (<>
    <ModalFiltro
    >
        <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 50, borderBottom: '1px solid #ccc' }}>

          <h2>Filtros</h2>
        </section>
        <section
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            gap: 8,
            fontSize: '1.2rem'
          }}
        >
          <SelectSede
            action={getSede}
            value={dados?.sede}
          />
          <SelectMinisterio
            idsede={dadoSubmit?.sede || dados?.sede}
            action={getMinisterio}
            value={dados?.ministerio}

          />
          <SelectCelula
            idministerio={dadoSubmit?.ministerio || dados?.ministerio}
            action={getCelula}
            value={dados?.celula}

          />
          <section>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
              <Button
                onClick={reset}
                color="error"
                disabled={isLoading}
              >
               Limpar
              </Button>
              <Button
                type="button"
                onClick={submit}
                disabled={isLoading}
              >
                    Confirmar
              </Button>
            </div>

          </section>
        </section>
    </ModalFiltro>
  </>);
}

export default FiltroPG;
